class ProviderReference {
    constructor(firstGroup, secondGroup, thirdGroup, fourthGroup, fifthGroup, sixthGroup, seventhGroup, eighthGroup) {
        this.firstGroup = firstGroup;
        this.secondGroup = secondGroup;
        this.thirdGroup = thirdGroup;
        this.fourthGroup = fourthGroup;
        this.fifthGroup = fifthGroup;
        this.sixthGroup = sixthGroup;
        this.seventhGroup = seventhGroup;
        this.eighthGroup = eighthGroup;
    }
}

export default ProviderReference;